import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'opt-coming-soon',
  templateUrl: './coming-soon.component.html',
  //styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
